import React from 'react';
import Content from './Content';

const MainPanel = () => {
    return (
        <div className="main-panel">
            <Content/>
        </div>

    );
}

export default MainPanel;